<template>
  <div class="px-30px p">
    <template>
      <p class="pb-10px">
        <span v-if="isShowIndex">{{ orderNum }}.</span>【{{ questionListMap }}】&nbsp;{{
          row.topic
        }}
      </p>
      <div class="pb-10px" v-if="[0, 1, 2].includes(row.examType)" :class="classWrap()">
        <div class="mb-8px min-w-1/5" v-for="(item, index) in answerList" :key="index">
          <el-checkbox :value="item.checked">{{ words[index] }}、{{ item.content }}</el-checkbox>
        </div>
      </div>
      <div v-html="row.correct" class="ql-editor" v-if="[3, 4].includes(row.examType)"></div>
    </template>
  </div>
</template>

<script>
import { wordsList } from '@/components/safety/enumField/enumTagType'
import { typeList } from './EnumField'

export default {
  name: 'question-content-view',
  props: {
    // 行数据
    row: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    // 分页配置
    pageConfig: {
      type: Object,
      default: () => {},
    },
    // 是否显示题目的索引
    isShowIndex: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {},
  data() {
    return {
      words: wordsList,
      // 题目类型
      questionList: typeList,
    }
  },
  computed: {
    questionListMap() {
      return (
        _.find(this.questionList, (item) => {
          return item.code === this.row.examType
        })?.displayName || ''
      )
    },
    orderNum() {
      return Number(
        this.index + 1 + this.pageConfig.MaxResultCount * (this.pageConfig.SkipCount - 1)
      )
    },
    answerList() {
      if (!this.row.topicContent) {
        return ''
      }
      return JSON.parse(this.row.topicContent)
    },
  },
  methods: {
    classWrap() {
      if (this.row.examType !== 2) {
        return ['flex', 'justify-between', 'flex-wrap']
      }
      return []
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-checkbox__label {
  display: inline;
  white-space: normal;
}

::v-deep .el-radio__label {
  display: inline;
  white-space: normal;
}

.ql-editor {
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 0px;
}
</style>
